import api from "../api/firebase.api.js"

export function to(promiseArg) {
  return promiseArg.then((data) => data).catch((error) => error)
}

const asyncComponentTester = (importPromise, latency) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(importPromise)
    }, latency)
  })
}

export { asyncComponentTester }

export async function apiWrapper(mainFunction, args) {
  let result = null
  // eslint-disable-next-line no-useless-catch
  try {
    result =
      args && Array.isArray(args)
        ? await mainFunction.apply(api, args)
        : await mainFunction(args)
    if (result && result.error) throw new Error(result.error)
  } catch (error) {
    throw error
  }
  return result
}
